module.exports = __webpack_public_path__ + "img/commission2.c12c5c5f.png";